module.exports = __webpack_public_path__ + "img/model-2@2x.abb541a.png";